import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./administrationStyle.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import dayjs, { Dayjs } from 'dayjs';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {format} from 'date-fns';
import {TextField} from '@mui/material';

import { MdDelete } from "react-icons/md";

import AdministrationNavbar from "../administrationNavbar/administrationNavbar";

export default function Settings() {
    const navigate = useNavigate();

    const [users, setUsers] = useState([]);
    const [showRequestsPopup, setShowRequestsPopup] = useState(false);
    const [showGalleryPopup, setShowGalleryPopup] = useState(false);
    const [showCalendarPopup, setShowCalendarPopup] = useState(false);
    const [showUserPopup, setShowUserPopup] = useState(true);

    const [title, setTitle] = useState("");
    const [location, setLocation] = useState("");
    const [description, setDescription] = useState("");
    const [date, setDate] = useState(new Date());
    const [events, setEvents] = useState([]);
    const [selectedCalendar, setSelectedCalendar] = useState();
    const [requests, setRequests] = useState([]);
    const [gallery, setGallery] = useState([]);
    const [imageName, setImageName] = useState("");
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [selectedImage, setSelectedImage] = useState();

    useEffect(() => {
        document.title = "DJ - EMAN"

        getAllUsers();
        getRequests();
        getGallery();
        getEvents();
    }, []);

    const getAllUsers = async () => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/allusers?token=" + Cookies.get("token"), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            });

            if (response.ok) {
                const data = await response.json();
                setUsers(data);
            } else {
                toast.error("Die Nutzerdaten konnten nicht geladen werden");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const getRequests = async () => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/bookingrequests?token=" + Cookies.get("token"), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            });

            if (response.ok) {
                const data = await response.json();
                setRequests(data);
            } else {
                toast.error("Die Booking Anfragen konnten nicht geladen werden");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const getGallery = async () => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/gallery", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            });

            if (response.ok) {
                const data = await response.json();
                setGallery(data);
            } else {
                toast.error("Die Galerie konnten nicht geladen werden");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const changeLockState = async (userId, state) => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/lockuser?token=" + Cookies.get("token") + "&userId=" + userId + "&state=" + state, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: null,
            });

            if (response.ok) {
                getAllUsers();
            } else {
                toast.error("Der Nutzer konnte nicht gesperrt werden");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const getEvents = async (e) => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/nextevents", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            });

            if (response.status == 200) {
                setEvents(await response.json());
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const addEvent = async () => {
        if (!date) {
            return;
        }
        try {
            const isoString = format(date, "yyyy-MM-dd'T'HH:mm:ss");

            const eventData = {
                title: title,
                location: location,
                description: description,
                date: isoString,
                isPublic: 1,
            }

            const response = await fetch("https://djeman.de:8443/api/v1/add-event?token=" + Cookies.get("token"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(eventData),
            });

            if (response.ok) {
                setTitle("");
                setLocation("");
                setDescription("");
                setDate(new Date());
                getEvents();
                toast.success("Das Event wurde eingetragen");
            } else {
                toast.error("Das Event konnte nicht eingetragen werden");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const addImage = async (e) => {
        if (!image || !imageName) {
            toast.error("Nicht alle Felder ausgefüllt");
            return;
        }

        const formData = new FormData();
        formData.append("image", image);
        formData.append("name", imageName);

        try {
            const response = await fetch("https://djeman.de:8443/api/v1/gallery?token=" + Cookies.get("token"), {
                method: "POST",
                body: formData
            });

            if (response.status == 201) {
                getGallery();
                setImageName("");
                setImage(null);
                setPreview(null);
                toast.success("Bild erfolgreich hochgeladen");
            } else {
                toast.error("Bild konnte nicht hochgeladen werden");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const deleteRequest = async (id) => {
        if (!id) {
            toast.error("Booking Anfrage kann nicht gelöscht werden");
            return;
        }

        try {
            const response = await fetch("https://djeman.de:8443/api/v1/bookingrequest?token=" + Cookies.get("token") + "&id=" + id, {
                method: "DELETE"
            });

            if (response.status == 200) {
                getRequests();
                toast.success("Booking Anfrage erfolgreich gelöscht");
            } else {
                toast.error("Booking Anfrage konnte nicht gelöscht werden");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const deleteEvent = async () => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/delete-event?token=" + Cookies.get("token") + "&eventId=" + selectedCalendar, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.ok) {
                getEvents();
                toast.success("Das Event wurde gelöscht");
            } else {
                toast.error("Das Event konnte nicht gelöscht werden");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const deleteImage = async (e) => {
        if (!selectedImage?.id) {
            toast.error("Kein Bild ausgewählt");
            return;
        }

        try {
            const response = await fetch("https://djeman.de:8443/api/v1/gallery?token=" + Cookies.get("token") + "&id=" + selectedImage.id, {
                method: "DELETE"
            });

            if (response.status == 200) {
                getGallery();
                setSelectedImage(null);
                toast.success("Bild erfolgreich gelöscht");
            } else {
                toast.error("Bild konnte nicht gelöscht werden");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    function switchSide(side) {
        navigate(side);
    }

    const handleChange = (event) => {
        setSelectedCalendar(event.target.value);
    }

    const handleNavbarClick = (value) => {
        if (value == 1) {
            getRequests();
            setShowRequestsPopup(true);
            setShowGalleryPopup(false);
            setShowCalendarPopup(false);
            setShowUserPopup(false);
        } else if (value == 2) {
            setShowRequestsPopup(false);
            setShowGalleryPopup(true);
            setShowCalendarPopup(false);
            setShowUserPopup(false);
        } else if (value == 3) {
            setShowRequestsPopup(false);
            setShowGalleryPopup(false);
            setShowCalendarPopup(true);
            setShowUserPopup(false);
        } else if (value == 4) {
            setShowRequestsPopup(false);
            setShowGalleryPopup(false);
            setShowCalendarPopup(false);
            setShowUserPopup(true);
        }
    };

    const handleChangeGallery = (e) => {
        const id = e.target.value;
        const foundImage = gallery.find(img => img.id == id)
        setSelectedImage(foundImage);
    }

    return (
        <div className="administrationContainer">
            <div className="contentContainer">
                <ToastContainer
                    theme="dark"
                />
                {showRequestsPopup && (
                    <div className="modalOverlay">
                        <div className="modalContent" onClick={(e) => e.stopPropagation()}>
                            <h1>Booking Anfragen</h1>
                            <div className="galleryContainer">
                                <div className="galleryItem">
                                    <h2>Alle Anfragen</h2>
                                    <div className="requestContainer">
                                        {requests.map((request, index) => (
                                            <div key={request.id} className="requestItem">
                                                <div className="requestContent">
                                                    <div className="requestTextContainer">
                                                        <h1>{request.name}</h1>
                                                        <h2>{request.text}</h2>
                                                        <h3>{request.email}</h3>
                                                        <h4>{new Date(request.createdAt).toLocaleString("de-DE", {dateStyle: "long", timeStyle: "short"})}</h4>
                                                    </div>
                                                    <div className="requestDeleteContainer">
                                                        <div className="requestDeleteItem" onClick={() => deleteRequest(request.id)}>
                                                            <MdDelete className="deleteIcon" />
                                                        </div>
                                                    </div>
                                                </div>
                                                {index !== requests.length - 1 && (
                                                    <div className="requestLine" />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {showGalleryPopup && (
                    <div className="modalOverlay">
                        <div className="modalContent" onClick={(e) => e.stopPropagation()}>
                            <h1>Galerie</h1>
                            <div className="galleryContainer">
                                <div className="galleryItem">
                                    <h2>Aktuelle Gallerie</h2>
                                    <select
                                        id="gallerySelect"
                                        value={selectedImage?.id}
                                        onChange={handleChangeGallery}
                                    >
                                        <option value="">Bitte wählen</option>
                                        {gallery.map((image) => (
                                            <option key={image.id} value={image.id}>
                                                {image.name}
                                            </option>
                                        ))}
                                    </select>
                                    {selectedImage && (
                                        <img src={`https://djeman.de:8443/api/v1/gallery/image/${selectedImage?.uuid}`} alt="Preview" className="imagePreview" />
                                    )}
                                    <div className="deleteButton" onClick={() => deleteImage()}>
                                        <h3>Löschen</h3>
                                    </div>
                                </div>
                                <div className="galleryItem">
                                    <h2>Bilder hinzufügen</h2>
                                    <input
                                        type="text"
                                        placeholder="Titel"
                                        value={imageName}
                                        onChange={(e) => setImageName(e.target.value)}
                                        className="textInput"
                                    />
                                    {preview && (
                                        <img src={preview} alt="Preview" className="imagePreview" />
                                    )}
                                    <input
                                        type="file"
                                        className="imageInput"
                                        onChange={(e) => {
                                            const file = e.target.files?.[0];
                                            setImage(file);

                                            if (file) {
                                                setPreview(URL.createObjectURL(file));
                                            } else {
                                                setPreview(null);
                                            }
                                        }}
                                    />
                                    <div className="addButton" onClick={() => addImage()}>
                                        <h3>Hinzufügen</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {showCalendarPopup && (
                    <div className="modalOverlay">
                        <div className="modalContent" onClick={(e) => e.stopPropagation()}>
                            <h1>Event Termine</h1>
                            <div className="galleryContainer">
                                <div className="galleryItem">
                                    <h2>Aktuelle Termine</h2>
                                    <select
                                        id="gallerySelect"
                                        value={selectedCalendar}
                                        onChange={handleChange}
                                    >
                                        <option value="">Bitte wählen</option>
                                        {events.map((event) => (
                                            <option key={event.id} value={event.id}>
                                                {event.title}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="deleteButton" onClick={() => deleteEvent()}>
                                        <h3>Löschen</h3>
                                    </div>
                                </div>
                                <div className="galleryItem">
                                     <h2>Termine hinzufügen</h2>
                                     <input
                                         type="text"
                                         placeholder="Titel"
                                         value={title}
                                         onChange={(e) => setTitle(e.target.value)}
                                         className="textInput"
                                     />
                                     <input
                                         type="text"
                                         placeholder="Location"
                                         value={location}
                                         onChange={(e) => setLocation(e.target.value)}
                                         className="textInput"
                                     />
                                     <input
                                         type="text"
                                         placeholder="Beschreibung"
                                         value={description}
                                         onChange={(e) => setDescription(e.target.value)}
                                         className="textInput"
                                     />
                                     <DatePicker
                                        selected={date}
                                        onChange={(date) => setDate(date)}
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        timeIntervals={15}
                                        dateFormat="dd.MM.yyyy HH:mm"
                                        className="datePicker"
                                     />
                                     <div className="addButton" onClick={() => addEvent()}>
                                         <h3>Hinzufügen</h3>
                                     </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {showUserPopup && (
                    <div className="modalOverlay">
                        <div className="modalContent" onClick={(e) => e.stopPropagation()}>
                            <h1>Benutzer</h1>
                            <div className="table-wrapper">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Nutzername</th>
                                            <th>E-Mail</th>
                                            <th>Rolle</th>
                                            <th>Newsletter</th>
                                            <th>Gesperrt</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users.map((user) => (
                                            <tr>
                                                <th>{user.id}</th>
                                                <th>{user.username}</th>
                                                <th>{user.email}</th>
                                                <th>{user.role}</th>
                                                <th>
                                                    {user.newsletter ? "Ja" : "Nein"}
                                                </th>
                                                <th style={{backgroundColor: !user.access ? 'red' : 'green'}} onClick={() => changeLockState(user.id, !user.access)}>
                                                    {user.access ? "Nein" : "Ja"}
                                                </th>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
                <AdministrationNavbar onItemClick={handleNavbarClick} />
            </div>
        </div>
    )
}
